<mat-progress-spinner [diameter]="45" class="mat-progress-spinner" [mode]="mode()" [value]="Progress$ | async">
</mat-progress-spinner>
